import React, { Component, useState } from 'react';
import { ResponsivePie } from '@nivo/pie';
import { ResponsiveBullet } from '@nivo/bullet'
import { Modal, Button, Row, Col, Spin, message, Input } from 'antd';
import MediaQuery from 'react-responsive'

import Chart from "react-apexcharts";
import './result.css';
import { getRadarOption, getPieData, getPieLegend, getBulletData, getTypeList, getBulletAverageData } from "./resultData";
import ResultDreamModal from "./resultDreamModal";
import ResultJobModal from "./resultJobModal";

import resultImage from '../static/result-title.png';
import hkfwsLogoImage from '../static/HKFWS.png';
import YDCImage from '../static/YDC.png';
import IgniteImage from '../static/Ignite.png';
import RImage from '../static/resultbtn-maintenance.png';
import IImage from '../static/resultbtn-magnifying.png';
import AImage from '../static/resultbtn-paint.png';
import SImage from '../static/resultbtn-conversation.png';
import EImage from '../static/resultbtn-work.png';
import CImage from '../static/resultbtn-notepad.png';
import moreImage from '../static/resultbtn-more.png';
import btnTip from '../static/button-left.png';
import resultBulb from '../static/result-bulb.png';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    resultGet,
    getStudentReport,
    getAverageData,
    getReportEmail,
} from '../../modules/result';
import Translate from "../translate/Translate";

import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
import { saveAs } from 'file-saver'

const ref = React.createRef();

class Result extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            radarData: null,
            bulletData: null,
            pdfloading: false,
            dreamVisible: false,
            TypeList: [],
            inputEmail: "",
            isModalVisible: {
                R: false,
                I: false,
                A: false,
                S: false,
                E: false,
                C: false,
                dream: false,
                job: false,
            },
            pieData: [
                {
                    "id": "男",
                    "label": "男",
                    "value": 0,
                    "color": "#546FE0"
                },
                {
                    "id": "女",
                    "label": "女",
                    "value": 0,
                    "color": "#D454E0"
                },
            ],
            C1: "你對常規型活動的興趣較低，你可以嘗試擔任制服團隊、圖書館管理員、校內有關財政或秘書的職務、砌砌圖、參與硬筆書法活動和安排行程等等，以發掘更多對常規型活動的興趣。",
            C2: "你於常規型技能的能力較低，你可以學習財務管理技巧、收納技巧、組織能力、核對資料能力等等，以提高常規型技能，幫助你解決日常生活中的難題。",
            C3: "你對常規型職業的興趣較低，你可以認識更多常規型職業，例如秘書、會計文員、投資分析員、保險理賠文員、出納員、法庭記者和紀律部隊等等，以擴闊對常規型職業的認識和興趣。",
            C4: "你在常規型的整體分數較低，若果你將來的生活或工作需要按規則及步驟進行、工作內容較單一及有規律性、需留意細節、記錄、歸檔和處理資料等等，你可能會感到困難或不適應，你可以提升常規型的能力以幫助你應付這些情況。",
            E1: "你對企業型活動的興趣較低，你可以嘗試參與校內領袖團隊或主席角色、參與辯論學會、創立學會和嘗試開展一門小生意等等，以發掘更多對企業型活動的興趣。",
            E2: "你於企業型技能的能力較低，你可以學習辯論技巧、領導技巧、推銷技巧和應變技巧等等，以提高企業型技能，幫助你解決日常生活中的難題。",
            E3: "你對企業型職業的興趣較低，你可以認識更多企業型職業，例如項目經理、銷售員、活動統籌、理財顧問、律師、法官和政務主任等等，以擴闊對企業型職業的認識和興趣。",
            E4: "你在企業型的整體分數較低，若果你將來的生活或工作需要作出策劃、經營、管理、勸服、監督、領導、臨時應變和以明確目標為本，你可能會感到困難或不適應，你可以提升企業型的能力以幫助你應付這些情況。",
            S1: "你對社交型活動的興趣較低，你可以嘗試參與義務工作、校內服務團隊、社區服務活動、教導兒童和幫助有需要的人士等等，以發掘更多對社交型活動的興趣。",
            S2: "你於社交型技能的能力較低，你可以參加團體活動去學習溝通及合作技巧、學習成長心理學、與不同個性的人相處和了解別人的需要而幫助他人等等，以提高社交型技能，幫助你解決日常生活中的難題。",
            S3: "你對社交型職業的興趣較低，你可以認識更多社交型職業，例如老師、社工、治療師、輔導員、幼兒教育老師和顧客服務等等，以擴闊對社交型職業的認識和興趣。",
            S4: "你在社交型的整體分數較低，若果你將來的生活或工作需要經常與人接觸、溝通、合作、教導別人、服務社區和以人為本，你可能會感到困難或不適應，你可以提升社交型的能力以幫助你應付這些情況。",
            A1: "你對藝術型活動的興趣較低，你可以嘗試參與有關繪畫、音樂、設計、跳舞、戲劇和寫作等等，以發掘更多對藝術型活動的興趣。",
            A2: "你於藝術型技能的能力較低，你可以嘗試學習一門藝術、樂器、舞蹈、設計宣傳品、撰寫小說/劇本等等，以提高藝術型技能，幫助你解決日常生活中的難題。",
            A3: "你對藝術型職業的興趣較低，你可以認識更多藝術型職業，例如畫家、雕塑家、音樂人、設計師、建築師、舞蹈員、演員、導演、廣告製作人、作家、記者和編輯等等，以擴闊對藝術型職業的認識和興趣。",
            A4: "你在藝術型的整體分數較低，若果你將來的生活或工作需要有創意、有美感、有直覺、有彈性或需以不同的媒介去表達想法、美善和感受等等，你可能會感到困難或不適應，你可以提升藝術型的能力以幫助你應付這些情況。",
            I1: "你對探究型活動的興趣較低，你可以嘗試參與與科學有關的活動、觀看與流行科學、科技、歷史、考古及自然紀錄片的影片和研究某一個專門領域等等，以發掘更多對探究型活動的興趣。",
            I2: "你於探究型技能的能力較低，你可以嘗試瞭解更多科學知識及數學公式、閱讀推理小說和玩數獨及IQ題，以提高探究型技能，幫助你解決日常生活中的難題。",
            I3: "你對探究型職業的興趣較低，你可以認識更多探究型職業，例如醫生、藥劑師、護士、工程師、投資分析師和生物/化學/物理/天文/人類/植物/歷史/考古/社會學家等等，以擴闊對探究型職業的認識和興趣。",
            I4: "你在探究型的整體分數較低，若果你將來的生活或工作需要獨立思考、處理資訊或作深入的分析及研究等等，你可能會感到困難或不適應，你可以提升探究型的能力以幫助你應付這些情況。",
            R1: "你對實務型活動的興趣較低，你可以嘗試參與木工、金工、廚藝、砌模型和機械人設計活動等等，以發掘更多對實務型活動的興趣。",
            R2: "你於實務型技能的能力較低，你可以嘗試學習使用不同的工具/廚具/器材、砌電腦和維修傢俱/電器等等，以提高實務型技能，幫助你解決日常生活中的難題。",
            R3: "你對實務型職業的興趣較低，你可以認識更多實務型職業，例如咖啡師、甜品師、裝修工人、水電技工、音響及電器技師和消防員等等，以擴闊對實務型職業的認識和興趣。",
            R4: "你在實務型的整體分數較低，若果你將來的生活或工作有機會使用到工具及機器、需要體力勞動或長期處於室外工作等等，你可能會感到困難或不適應，你可以提升實務型的能力以幫助你應付這些情況。"
        }
    }

    componentDidMount() {
        if (!this.props.resultData) {
            this.getCurrentResult();
        } else if (!this.state.radarData) {
            this.getCurrentResult();
        }
    }

    getCurrentResult() {
        // console.log(this.props.resultData)
        this.props.resultGet().then(
            async () => {
                // console.log(this.props.resultData);
                if (this.props.resultData) {
                    let radarOpition = await getRadarOption(this.props.language);
                    let type = await getTypeList(this.props.language);
                    let bullet = await getBulletAverageData();
                    let pieOption = await getPieData(this.props.language, bullet, this.props.resultData);
                    this.setState({
                        radarData: {
                            series: [{
                                name: 'Score',
                                data: [this.props.resultData.totalScore.R, this.props.resultData.totalScore.I, this.props.resultData.totalScore.A, this.props.resultData.totalScore.S, this.props.resultData.totalScore.E, this.props.resultData.totalScore.C], //get from api
                            }],
                            options: radarOpition,
                        },
                        pieData: pieOption,
                        TypeList: type,
                        bulletData: bullet
                    });

                }

            }
        ).catch(function (error) {
            // this.setState({ loading: false });
            message.error("未能成功獲取測試結果。")
            setTimeout(() => {
                this.props.history.push("/")
            }, 5000);
        }.bind(this));
        ;

    }

    showModal = (type) => {
        let tmp = { ...this.state.isModalVisible };
        tmp[type] = true;
        this.setState({ isModalVisible: tmp });
    };


    handleCancel = (type) => {
        let tmp = { ...this.state.isModalVisible };
        tmp[type] = false;
        this.setState({ isModalVisible: tmp });
    };

    finish = () => {
        localStorage.clear();
        this.props.history.push('/');
    }

    sendEmail = () => {
        const { inputEmail } = this.state;
        const re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
        if (re.test(inputEmail.toLowerCase()) && inputEmail.length <= 64) {
            this.setState({ loading: true });
            this.props.getReportEmail({ email: inputEmail }).then(() => {
                this.setState({ askEmail: false, loading: false });
                setTimeout(message.success('發送電郵成功'), 2000);
            }).catch((err) => {
                this.setState({ loading: false });
                setTimeout(message.error('發送電郵失敗，請重新輸入'), 2000);
            })
        } else {
            setTimeout(message.error('電郵的格式錯誤'), 2000);
        }
    }

    onEmailChange = (e) => {
        this.setState({
            inputEmail: e.target.value,
        })
    }

    generateStudentReportPdf = () => {
        console.log("generateReportPdf");
        const hide = message.loading('處理中，請稍候..', 0);

        this.props.getStudentReport().then((res) => {
            const blob = new Blob([res], { type: 'application/pdf' })
            saveAs(blob, `SDS_Report.pdf`);
            setTimeout(hide, 100);
        })
        setTimeout(hide, 100);
    }

    generatePdf = () => {
        // console.log("in");
        this.setState({ pdfloading: true }, () => { setTimeout(() => this.generatePdfFx(), 1000) })
    }

    generatePdfFx = () => {
        // console.log("downloading")
        html2canvas(document.body).then(
            async function (canvas) {
                const imgData = canvas.toDataURL('image/png');
                var pdf;
                if (window.innerWidth > 768) {
                    pdf = new jsPDF("p", "mm", [250, 250]);
                } else {
                    pdf = new jsPDF("p", "mm", [100, 500]);
                }
                var width = pdf.internal.pageSize.getWidth();
                var height = pdf.internal.pageSize.getHeight();
                pdf.setFontSize(10);

                var header = "SDS Report - StudentCode: " + JSON.parse(window.localStorage.u).student.studentCode;
                pdf.text(header, 1, 5);
                pdf.addImage(imgData, 'PNG', -10, 10, width, height);
                await pdf.save("sds_report.pdf");
            }
        ).then(
            setTimeout(() => this.setState({ pdfloading: false }), 2000)

        );
    }


    render() {

        const { isModalVisible, loading } = this.state;
        const image = { R: RImage, I: IImage, A: AImage, S: SImage, E: EImage, C: CImage };

        return (
            <div className="backgroundContainer">
                <div className="resultContainer" id="resultContainer">
                    <div className="resultImageContainer titleBgColor">
                        <div>
                            <img src={resultImage} className="resultImage" onError={e => { console.log(e) }}></img>
                            <h1><Translate id="result.title" /></h1>
                        </div>
                        <div className="logos">
                            <img src={YDCImage} className="resultImage" onError={e => { console.log(e) }}></img>
                            <img src={hkfwsLogoImage} className="resultImage" onError={e => { console.log(e) }}></img>
                            <img src={IgniteImage} className="resultImage" onError={e => { console.log(e) }}></img>
                        </div>
                    </div>
                    {(this.props.resultData) ?
                        <div className="resultDataContainer">
                            <div className="typeRankContainer">
                                {
                                    this.props.resultData.ranking.map(
                                        (type, rank) => {

                                            const display = type.map(
                                                (result, i) => {
                                                    // console.log(this.props.resultData["totalScore"][result]);
                                                    let propsData = this.props.resultData;
                                                    return (
                                                        <div key={result}>
                                                            <img src={btnTip} className="resultbtnTip"></img>
                                                            <div className="resultBtnTipText">{rank + 1}<span className="rankIndicator">{(rank + 1) > 3 ? "th" : (rank + 1) == 3 ? "rd" : (rank + 1) == 2 ? "nd" : "st"}</span></div>
                                                            <Button type="primary" className={"resultRankBtn  resultBtnColor" + (result)} onClick={this.showModal.bind(this, result)}>
                                                                <span>{result}</span>&nbsp;
                                                                <Translate id={`type.${result}`} />
                                                                <img src={image[result]} className="resultBtnImg"></img>
                                                                <span className="resultBtnMarkLable"><Translate id="result.mark" /></span>
                                                                {propsData["totalScore"][result]}
                                                                <img src={moreImage} className="resultBtnMore"></img>
                                                            </Button>
                                                            <Modal
                                                                title={<Translate id="result.mark.detail.title" />}
                                                                visible={isModalVisible[result]}
                                                                onCancel={this.handleCancel.bind(this, result)}
                                                            >
                                                                <Row>
                                                                    <Col span="12"><p> <Translate id={`type.${result}`} /></p><p></p>
                                                                        <p className="popuptextColor"><Translate id="questions.activities.title" />: {propsData["activitiesScore"][result]}/14</p>
                                                                        <p className="popuptextColor"><Translate id="questions.competencies.title" />: {propsData["competenciesScore"][result]}/14</p>
                                                                        <p className="popuptextColor"><Translate id="questions.occupations.title" />: {propsData["occupationsScore"][result]}/14</p>
                                                                        <p className="popuptextColor"><Translate id="questions.self.title" /></p>
                                                                        <p className="popuptextColor">&nbsp;&nbsp;&nbsp;&nbsp;<Translate id="result.mark.detail.self1" />: {propsData["self1Score"][result]}/7</p>
                                                                        <p className="popuptextColor">&nbsp;&nbsp;&nbsp;&nbsp;<Translate id="result.mark.detail.self2" />: {propsData["self2Score"][result]}/7</p></Col>
                                                                    <Col span="12">
                                                                        <p className="resultpoptitleContasiner"><img src={resultBulb} className="resultpopimg"></img> <Translate id="result.mark.detail.tips" /> </p>
                                                                        <p className="popuptextColor">{propsData["activitiesScore"][result] < 4 ? this.state[result + "1"] : ""}</p>
                                                                        <br></br>
                                                                        <p className="popuptextColor">{propsData["competenciesScore"][result] < 4 ? this.state[result + "2"] : ""}</p>
                                                                        <br></br>
                                                                        <p className="popuptextColor">{propsData["occupationsScore"][result] < 4 ? this.state[result + "3"] : ""}</p>
                                                                        <br></br>
                                                                        <p className="popuptextColor">{propsData["activitiesScore"][result] + propsData["competenciesScore"][result] + propsData["occupationsScore"][result] < 10 ? this.state[result + "4"] : ""}</p>
                                                                    </Col>
                                                                </Row>
                                                            </Modal>
                                                        </div>
                                                    )
                                                }
                                            )
                                            return (display)
                                        }
                                    )
                                }

                                {/* --------------------------Radar------------------------- */}
                            </div>
                            <div className="radarContainer">
                                <h1 className="resultTitleColor"><Translate id="result.subtitle1" /></h1>
                                <div className="radarGraphContainer">
                                    {(this.state.radarData) ?
                                        <Chart responsive={this.state.responsive} options={this.state.radarData.options} series={this.state.radarData.series} type="radar" height={'100%'} width={'120%'} />
                                        : null}
                                </div>

                                <div className="radarBtnContainer">
                                    <Button type="primary" className="resultBtn" onClick={() => this.setState({ dreamVisible: true })}><Translate id="resultDream.title" /></Button>
                                    {/* {(this.state.dreamVisible) ? */}
                                    {/* -------------------------我的夢想職業------------------------ */}
                                    <Modal
                                        visible={this.state.dreamVisible}
                                        title={<Translate id="resultDream.title" />}
                                        onCancel={() => this.setState({ dreamVisible: false })}
                                        className="resultDreamSearchRedirectContainer"
                                    ><ResultDreamModal id="resultDream.title" /></Modal>
                                    {/* : null} */}
                                    <Button type="primary" className="resultBtn resultBtnMargin" onClick={() => this.setState({ jobVisible: true })}><Translate id="resultJob.title" /></Button>
                                    {/* -------------------------我的推薦職業------------------------ */}
                                    <Modal
                                        visible={this.state.jobVisible}
                                        title={<Translate id="resultJob.title" />}
                                        onCancel={() => this.setState({ jobVisible: false })}
                                        className="resultDreamSearchRedirectContainer"
                                    ><ResultJobModal id="resultDream.title" /></Modal>
                                    <Button type="primary" className="resultBtn" onClick={() => this.setState({ askVisible: true })}><Translate id="result.qa.title" /></Button>
                                    {/* -------------------------我要發問------------------------ */}
                                    <Modal
                                        visible={this.state.askVisible}
                                        title="我要發問"
                                        onCancel={() => this.setState({ askVisible: false })}
                                        content="....">
                                        <p>Instagram Link</p>
                                        <a href="https://www.instagram.com/ys.youthsquare/" target="_blank">https://www.instagram.com/ys.youthsquare/</a>
                                        <br></br>
                                        <p>Facebook PM Link</p>
                                        <a href="http://m.me/ys.youthsquare" target="_blank">http://m.me/ys.youthsquare</a>

                                    </Modal>
                                </div>
                            </div>

                            <div className="typeRankContainer pieChartContainer">
                                {
                                    this.props.resultData.ranking.map((type, rank) => {
                                        if (rank == 0) {
                                            const display = type.map((result, i) => {
                                                return (<h3 className="resultTitleColor" key={i}><Translate id={`type.${result}`} /><Translate id="result.subtitle2" /></h3>)
                                            });
                                            return (display)
                                        }
                                    })
                                }
                                {/* --------------------------Pie------------------------- */}
                                <div className="pieChart">
                                    {<ResponsivePie
                                        data={this.state.pieData}
                                        margin={{ top: 0, right: 30, bottom: 120, left: 30 }}
                                        innerRadius={0.5}
                                        padAngle={0.7}
                                        cornerRadius={1}
                                        colors={["#546FE0", "#D454E0"]}
                                        borderWidth={0}
                                        sliceLabel={(item) => `${item.value}%`}
                                        radialLabelsSkipAngle={10}
                                        radialLabelsTextColor="#000000"
                                        radialLabelsLinkColor={{ from: 'color' }}
                                        sliceLabelsSkipAngle={10}
                                        sliceLabelsTextColor="#000000"
                                        legends={getPieLegend()} />
                                    }
                                </div>
                            </div>
                            {/* --------------------------Bullet------------------------- */}
                            <div className="bulletContainer">
                                <h3 className="resultTitleColor"><Translate id="result.subtitle3" /></h3>
                                <div className="bullet">
                                    <MediaQuery minWidth={768}>
                                        <ResponsiveBullet
                                            data={getBulletData(this.props.resultData, this.state.TypeList, this.state.bulletData)}
                                            margin={{ top: 10, right: 20, bottom: 20, left: 100 }}
                                            spacing={23}
                                            titleAlign="start"
                                            titleOffsetX={-70}
                                            measureSize={0.3}
                                            rangeColors={["#A7CEE3"]}
                                            measureColors={["#FEE1DF"]}
                                            markerColors={["#1F77B4"]}
                                        />
                                    </MediaQuery>
                                    <MediaQuery maxWidth={768}>
                                        <ResponsiveBullet
                                            data={getBulletData(this.props.resultData, this.state.TypeList, this.state.bulletData)}
                                            margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                                            spacing={45}
                                            titleAlign="start"
                                            titleOffsetX={-5}
                                            titleOffsetY={-16}
                                            measureSize={0.3}
                                            rangeColors={["#A7CEE3"]}
                                            measureColors={["#FEE1DF"]}
                                            markerColors={["#1F77B4"]}
                                        />
                                    </MediaQuery>
                                </div>
                                <div className="bulletIndexContainer">
                                    <span className="avgColor bulletCircle"></span> <span className="bulletIndex"><Translate id="result.average" /></span>
                                    <span className="markColor bulletCircle"></span><span className="bulletIndex"><Translate id="result.mymark" /></span>
                                </div>

                            </div>
                            <div className="footerBtnContainer">
                                {(this.state.pdfloading) ?
                                    <Spin>
                                        <Button type="primary" className="resultFooterBtn" onClick={this.generatePdf.bind(this)} disabled={this.state.pdfloading}><Translate id="result.print" /></Button>
                                    </Spin>
                                    :
                                    <Button type="primary" className="resultFooterBtn" onClick={this.generatePdf.bind(this)} disabled={this.state.pdfloading}><Translate id="result.print" /></Button>
                                }
                                <Button type="primary" onClick={() => this.generateStudentReportPdf()} className="resultFooterBtn resultBtnMargin" ><Translate id="result.pdf" /></Button>
                                {/* -------------------------發送電郵------------------------ */}
                                {/* <Modal
                                    visible={this.state.askEmail}
                                    title="輸入電郵"
                                    onCancel={() => this.setState({ askEmail: false })}>
                                    <Input className="input-email" placeholder="Email" onChange={this.onEmailChange.bind(this)} />
                                    <Button type="primary" className="resultSendBtn" onClick={() => this.sendEmail()} loading={loading}><Translate id="result.send" /></Button>
                                </Modal> */}
                                {/* <Button type="primary" className="resultFooterBtn" onClick={() => this.setState({ askEmail: true })}><Translate id="result.email" /></Button> */}
                                <Button type="primary" className="resultFinishBtn" onClick={this.finish}><Translate id="result.finish" /></Button>
                            </div>

                        </div>
                        :
                        <div className="resultDataContainer"><div style={{ height: "75vh", width: "90vw", display: "flex", alignItems: "center", justifyContent: "center" }}><Spin size="large" /></div></div>}
                </div>

            </div>
        )
    }
}


const mapStateToProps = state => ({
    resultData: state.result.resultData,
    language: state.mainpage.language,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            resultGet,
            getStudentReport,
            getReportEmail,
        },
        dispatch
    );

//mapStateToProps should be passed as the 1st argument to connect
export default connect(mapStateToProps, mapDispatchToProps)(Result);